
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getIntenttype = async () => {
  return await get<ApiResponse<any[]>>("/intenttype").then((res)=>{
      return res
    })
};

 